import { createApp } from 'vue'
import { FocusTrap } from 'focus-trap-vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Loader from "@/components/Loader";

createApp(App).component('Loader',Loader).component('FocusTrap', FocusTrap).use(store).use(router).mount('#app')
